import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Input from '../../shared/form-elements/input';

let timer;

const propTypes = {
	form: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	action: PropTypes.func,
	autoFocus: PropTypes.bool
};

const defaultProps = {
	autoFocus: false,
	placeholder: 'Search'
};

const Main = props => (
	<div className="search-bar">
		<form action="#" onSubmit={e => { e.preventDefault(); props.action(); }}>
			<Field
				name="search"
				placeholder={props.placeholder}
				component={Input}
				showLabel={false}
				onChange={() => {
					clearTimeout(timer);
					timer = setTimeout(props.action, 400);
				}}
				autoFocus={props.autoFocus}/>
		</form>
	</div>
);

Main.propTypes = propTypes;
Main.defaultProps = defaultProps;

export default reduxForm({})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/search/main.js